import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Content, checkFocus } from '../CheckField/styles';

export interface OptionProps {
  isFocused: boolean;
}

export const Option = styled('div')<OptionProps>`
  padding: 0.5rem 2rem;

  &:not(:hover) {
    ${props =>
      props.isFocused &&
      css`
        ${Content} {
          &:before {
            ${checkFocus};
          }
        }
      `};
  }

  &:first-of-type {
    padding-top: 1.5rem;
  }

  &:last-child {
    padding-bottom: 2.3rem;
  }
`;
